<label class="cerrix-label" [for]="for" [class.required]="isRequired"
    ><ng-content></ng-content
></label>
